var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGradientGrayPolygon = function SvgGradientGrayPolygon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 146,
    height: 139,
    fill: "none",
    viewBox: "0 0 146 139"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#gradientGrayPolygon_svg__clip0_1126_15416)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "url(#gradientGrayPolygon_svg__paint0_linear_1126_15416)",
    strokeWidth: 8,
    d: "m4.724 81.55 23.828-64.822 68.05-11.775L140.827 58l-23.828 64.821-68.051 11.775z",
    opacity: 0.3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradientGrayPolygon_svg__paint0_linear_1126_15416",
    x1: 25.594,
    x2: 119.956,
    y1: 13.181,
    y2: 126.369,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#191A33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#191A33",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "gradientGrayPolygon_svg__clip0_1126_15416"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h146v139H0z"
  })))));
};
export default SvgGradientGrayPolygon;